module.exports = __webpack_public_path__ + "img/message-icon.df951cff.png";